// @flow

import { setShowSelectCaveatsModal } from '../../../State/showSelectCaveatsModal';

export default () => async (dispatch: Function) => dispatch(setShowSelectCaveatsModal(true));